"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'onboarding.status.pending': 'Pendiente',
    'onboarding.status.in_progress': 'En Progreso',
    'onboarding.status.completed': 'Completado',
    'onboarding.status.all': 'Todos los Estados',
    'onboarding.status.abandoned': 'Abandonado',
    'onboarding.status.unknown': 'Desconocido',
};
